<template>
  <statistik-base :value="value" :stats="stats"></statistik-base>
</template>

<script>
import StatistikBase from '@/components/shared/StatistikBase';
export default {
  name: 'Statistik',
  components: { StatistikBase },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      stats: [
        {
          icon: 'mdi-file-move',
          color: 'indigo',
          label: 'Dokumen Ajuan',
          key: '2',
          grid: { cols: 12, md: 2, sm: 6 },
        },
        {
          icon: 'mdi-file-lock',
          color: 'indigo',
          label: 'Dokumen Diproses',
          key: '3',
          grid: { cols: 12, md: 2, sm: 6 },
        },
        {
          icon: 'mdi-file-check',
          color: 'success',
          label: 'Diterima',
          key: '6',
          grid: { cols: 12, md: 2, sm: 6 },
        },
        {
          icon: 'mdi-file-alert',
          color: 'warning',
          label: 'Revisi',
          key: '5',
          grid: { cols: 12, md: 2, sm: 6 },
        },
        {
          icon: 'mdi-file-excel',
          color: 'red',
          label: 'Ditolak',
          key: '4',
          grid: { cols: 12, md: 2, sm: 6 },
        },
      ],
    };
  },
};
</script>

<style scoped></style>
